export default __webpack_public_path__ + "static/media/gravesblossom.8a319765.png";